import { render, staticRenderFns } from "./default-layout.vue?vue&type=template&id=eb8ecb54&scoped=true"
import script from "./default-layout.vue?vue&type=script&lang=ts"
export * from "./default-layout.vue?vue&type=script&lang=ts"
import style0 from "./default-layout.vue?vue&type=style&index=0&id=eb8ecb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8ecb54",
  null
  
)

export default component.exports